import _ from "lodash";

export const ellipsis = (address: string, size = 5) => `${address.slice(0, size)}…${address.slice(-size)}`;

export const formatRounded = (value: number, decimals = 6) => {
  if (value === 0) return 0;
  return _.round(value, decimals);
};


export const formatNumber = (number: number, decimals = 1) => {
  // Handle edge cases
  if (number === 0) return "0";
  if (!number) return "0";

  // Define suffixes and their thresholds
  const suffixes = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "K" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" }
  ];

  // Find the appropriate suffix
  const suffixItem = suffixes
    .slice()
    .reverse()
    .find(item => Math.abs(number) >= item.value);

  if (!suffixItem) return "0";

  // Calculate the formatted value
  const formattedValue = (number / suffixItem.value).toFixed(decimals);
  // Remove trailing zeros after decimal point
  const cleanValue = formattedValue.replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1");
  // Return the formatted string with suffix
  return cleanValue + suffixItem.symbol;
};
